import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import Styles from './ConnectionNeededItem.module.scss'
import { integrationToName } from 'components/IntegrationRequiredModal/IntegrationRequiredModal'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button/Button'
import { PlatformIcon } from 'screens/BrandKit/SourceMaterials/SourceMaterialsTable/PlatformIcon'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close } from 'blaze-ui/icons'

interface ConnectionNeededItemProps {
  provider: ExternalIntegrationEnum
  onConnect: () => void
  onRemove?: () => void
}

export const ConnectionNeededItem = ({ provider, onConnect, onRemove }: ConnectionNeededItemProps) => {
  return (
    <div className={Styles.root}>
      <PlatformIcon platform={provider} size={32} />
      <div className={Styles.name}>
        <Text>{integrationToName[provider]}</Text>
        <div className={Styles.actions}>
          <Button size="xs" variant="tertiary" onPress={onConnect}>
            Connect
          </Button>
          {onRemove && <IconButton size="xs" variant="tertiary" onPress={onRemove} icon={Close} />}
        </div>
      </div>
    </div>
  )
}
